import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-secondary-100">
      <div className="container-site grid gap-10 py-12 md:grid-cols-4 md:py-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-leaf-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">天才医仙漫画</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
            系统梳理《天才医仙漫画》医术修炼体系的中文知识站。从炼丹、针灸到功法进阶，帮你理清医仙之路的升级脉络与六大境界，想看主角如何一步步变强，这里全都有。
          </p>
        </div>

        <nav aria-label="网站导航">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-secondary-400">网站导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/" className="text-secondary-100 transition-colors hover:text-accent-300">首页</Link></li>
            <li><Link to="/xiulian" className="text-secondary-100 transition-colors hover:text-accent-300">修炼体系</Link></li>
            <li><Link to="/faq" className="text-secondary-100 transition-colors hover:text-accent-300">常见问题</Link></li>
            <li><Link to="/about" className="text-secondary-100 transition-colors hover:text-accent-300">关于我们</Link></li>
          </ul>
        </nav>

        <nav aria-label="修炼体系">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-secondary-400">修炼体系</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/xiulian" className="text-secondary-100 transition-colors hover:text-accent-300">炼丹之道</Link></li>
            <li><Link to="/xiulian" className="text-secondary-100 transition-colors hover:text-accent-300">针灸通脉</Link></li>
            <li><Link to="/xiulian" className="text-secondary-100 transition-colors hover:text-accent-300">功法进阶</Link></li>
            <li><Link to="/xiulian" className="text-secondary-100 transition-colors hover:text-accent-300">六大境界</Link></li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-secondary-700/60">
        <div className="container-site flex flex-col items-center justify-between gap-3 py-6 text-xs text-secondary-300 sm:flex-row">
          <p>© 2026 天才医仙漫画修炼体系站 · 仅供内容参考</p>
          <div className="flex items-center gap-2">
            <i className="ri-mail-line text-sm" aria-hidden="true"></i>
            <a href="mailto:hello@tiancaiyixian.com" className="transition-colors hover:text-accent-300">hello@tiancaiyixian.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}